<template>
  <div class="ui-input">
    <div class="ui-input-container">
      <div class="title">{{$t(title)}}</div>
      <div class="icons-left" v-if="$slots.left"><slot name="left"></slot></div>
      <!--<input class="input" :class="{'read-only':readonly, 'no-padding-left':$slots.left}" :autocapitalize="autocapitalize" :accept="accept" v-bind:type="type" v-model="model" :readonly="readonly">-->
      <select :key="updateKey" id="ui-select" class="select" v-model="model">
        <option disabled="true" value="">{{$t('language.make_a_choice')}}</option>
       
        <option v-for="(item, index) in select" :value="item.value" :key="index+String(item.selected)" >{{item.name}}</option>
      </select>
      
      <div class="icons-right">
        <font-awesome-icon class="icon" icon="caret-down" />
      </div>
    </div>
    <div class="after" v-if="$slots.after"><slot name="after"></slot></div>
  </div>
  
</template>

<script>

export default {
  name: 'ui-select',
  props:{
    type:{default:"text"},
    autocapitalize:{default:"on"},
    title:{default:""},
    readonly:{default:false},
    accept:{default:"*"},
    select:{default:[{value:"0",name:"saab"},{value:"1",name:"ford"}]},
  },
  methods:{
    focus(e){
      
        e.preventDefault(); e.stopPropagation();
        window.scrollTo(0,100); //the second 0 marks the Y scroll pos. Setting this to i.e. 100 will push the screen up by 100px. 
           
    },
    updateSelectedValue(){
    
    if(!this.select.length){
      return;
    }
      this.select.forEach(item=>{
        if(item.selected){
          this.val=item.value;
        }
      })
    //this.$emit('input', "");
    this.$emit('input', this.val);
    },
  },
  data:function(){
    return {
      val:"",
      on:false,
      inputValue:"",
      updateKey:0,
    }
  },
  mounted(){
    
    // set selected
    this.updateSelectedValue();
    
  },
  computed:{
    model:{
      get(){
        return this.val
      },
      set(v){
        this.$emit('input', v);
      }
    },
  },
  watch:{
    select:function(){
      
       this.updateSelectedValue();
       this.updateKey=new Date().getTime();
    }
  }
 
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.icons-right{
  display:flex;
  align-items: center;
  margin-right:5px;
}
.icons-left{
  display:flex;
  align-items: center;
  margin-left:8px;
}
.ui-input{
  display:flex;
  margin-bottom:15px;
  align-items: center;
}
.ui-input-container{
  position:relative;
  border:1px solid #707070;
  border-radius:4px;
  display:flex;
  flex:1;
}
.after{
  padding:0 5px;
}
.title{
  padding:0 5px;
  position:absolute;
  font-size:.7em;
  display:inline-block;
  background-color:#FFFFFF;
  top: -8px;
  left: 5px;
}

select{
  border:1px solid red;
  border:none;
  width:100%;
  outline: none;
  font-size:1.0em;
  padding:8px 10px;
  background-color:transparent;
  -webkit-appearance: none;
  -moz-appearance: none;
}

.no-padding-left{
  padding-left:0px;
}

.read-only{
  color:#707070;
}
</style>
